import {Repository, createRepository} from '@/repositories/Base/Repository'

class MaterialRepository extends Repository {
    endpoint = 'tuevs/specimens'

    fetchAll(params) {
        if (params && params.mapping) {
            delete params.mapping
            return this.$axios.get(`mapping/specimens/table`, {params})
        }

        return super.fetchAll(params)
    }

    put(id, params) {
        return this.$axios.put(`${this.endpoint}/${id}/update`, params)
    }

    fetch(id) {
        return this.$axios.get(`${this.endpoint}/${id}/show`)
    }

    findAll(params) {
        return this.$axios.get(`${this.endpoint}/find/all`, {params})
    }

    fetchAllItems(params) {
        return this.$axios.get(`${this.endpoint}/all`, {params})
    }
}

export default new MaterialRepository()

export const create = createRepository(MaterialRepository)
